"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMITTENTE_DECLARATION_LABELS = exports.COMMITTENTE_DECLARATIONS = exports.updateRecordReferenceTypeSchema = exports.createRecordReferenceTypeSchema = exports.recordReferenceTypeLabelSchema = exports.recordReferenceTypeKeySchema = exports.recordReferenceRuleSchema = exports.updateProductConfigurationSchema = exports.updateCategorySchema = exports.createCategorySchema = exports.ticketChannelSchema = exports.categoryNameSchema = exports.RECORD_REFERENCE_TYPE_KEY_PATTERN = exports.RECORD_REFERENCE_TYPE_LABEL_MAX_LENGTH = exports.RECORD_REFERENCE_TYPE_KEY_MAX_LENGTH = exports.DEFAULT_ALLOW_RECORD_REFERENCE = exports.MAX_MIN_DESCRIPTION_LENGTH = exports.DEFAULT_MIN_DESCRIPTION_LENGTH = exports.CATEGORY_NAME_MAX_LENGTH = void 0;
const zod_1 = require("zod");
const ticket_channel_js_1 = require("./ticket-channel.js");
/**
 * Configurazione per prodotto letta dai consumer (PRD-003 US-2, DEC-003 punto 2, DEC-006 regola 7):
 * categorie di segnalazione in due set per canale, lunghezza minima della descrizione, tipi di
 * riferimento al record e regola «riferimento al record consentito» per committente (DEC-014).
 * Contratti condivisi fra API e web; i valori di dominio sono in italiano. Nessuna voce del canale
 * paziente (DEC-005).
 */
/** Lunghezza massima del nome di una categoria. */
exports.CATEGORY_NAME_MAX_LENGTH = 60;
/** Lunghezza minima della descrizione proposta a un prodotto nuovo. */
exports.DEFAULT_MIN_DESCRIPTION_LENGTH = 20;
/** Limite superiore della lunghezza minima: oltre, il form diventa inutilizzabile. */
exports.MAX_MIN_DESCRIPTION_LENGTH = 2000;
/**
 * Default sicuro della regola «riferimento al record consentito» (easycare DEC-101, DEC-014): vale
 * per i committenti senza regola e per i consumer che non riescono a leggere la configurazione.
 */
exports.DEFAULT_ALLOW_RECORD_REFERENCE = false;
/** Lunghezza massima della chiave di un tipo di riferimento al record (DEC-014). */
exports.RECORD_REFERENCE_TYPE_KEY_MAX_LENGTH = 60;
/** Lunghezza massima dell'etichetta di un tipo di riferimento al record (DEC-014). */
exports.RECORD_REFERENCE_TYPE_LABEL_MAX_LENGTH = 80;
/** Chiave stabile in kebab-case: minuscole e cifre separate da un trattino (`segnalazione-evento`). */
exports.RECORD_REFERENCE_TYPE_KEY_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
/** Nome di una categoria: senza spazi ai bordi, 1-60 caratteri. */
exports.categoryNameSchema = zod_1.z
    .string()
    .trim()
    .min(1, { error: 'Il nome della categoria è obbligatorio' })
    .max(exports.CATEGORY_NAME_MAX_LENGTH, { error: `Nome troppo lungo (massimo ${exports.CATEGORY_NAME_MAX_LENGTH} caratteri)` });
exports.ticketChannelSchema = zod_1.z.enum(ticket_channel_js_1.TICKET_CHANNELS, { error: 'Canale non valido' });
/** Corpo di `POST /products/:id/categories`. */
exports.createCategorySchema = zod_1.z.object({
    channel: exports.ticketChannelSchema,
    name: exports.categoryNameSchema,
});
/** Corpo di `PATCH /products/:id/categories/:categoryId`: nuovo nome e/o nuova posizione nel set. */
exports.updateCategorySchema = zod_1.z
    .object({
    name: exports.categoryNameSchema,
    position: zod_1.z.int({ error: 'Posizione non valida' }).min(0, { error: 'Posizione non valida' }),
})
    .partial()
    .refine((value) => value.name !== undefined || value.position !== undefined, {
    error: 'Nessun campo da aggiornare',
});
/** Corpo di `PATCH /products/:id/configuration`. */
exports.updateProductConfigurationSchema = zod_1.z.object({
    minDescriptionLength: zod_1.z
        .int({ error: 'Indica un numero intero di caratteri' })
        .min(0, { error: 'La lunghezza minima non può essere negativa' })
        .max(exports.MAX_MIN_DESCRIPTION_LENGTH, { error: `Al massimo ${exports.MAX_MIN_DESCRIPTION_LENGTH} caratteri` }),
});
/** Corpo di `PUT /products/:id/committenti/:committente/record-reference-rule` (DEC-014). */
exports.recordReferenceRuleSchema = zod_1.z.object({
    allowRecordReference: zod_1.z.boolean({ error: 'Indica se il riferimento al record è consentito' }),
});
/** Chiave di un tipo di riferimento: stabile, in kebab-case, 1-60 caratteri. Non si modifica dopo la creazione. */
exports.recordReferenceTypeKeySchema = zod_1.z
    .string()
    .trim()
    .min(1, { error: 'La chiave è obbligatoria' })
    .max(exports.RECORD_REFERENCE_TYPE_KEY_MAX_LENGTH, {
    error: `Chiave troppo lunga (massimo ${exports.RECORD_REFERENCE_TYPE_KEY_MAX_LENGTH} caratteri)`,
})
    .regex(exports.RECORD_REFERENCE_TYPE_KEY_PATTERN, {
    error: 'Solo lettere minuscole e cifre, separate da un trattino (es. segnalazione-evento)',
});
/** Etichetta di un tipo di riferimento, come la legge l'operatore nel dettaglio del ticket. */
exports.recordReferenceTypeLabelSchema = zod_1.z
    .string()
    .trim()
    .min(1, { error: 'L’etichetta è obbligatoria' })
    .max(exports.RECORD_REFERENCE_TYPE_LABEL_MAX_LENGTH, {
    error: `Etichetta troppo lunga (massimo ${exports.RECORD_REFERENCE_TYPE_LABEL_MAX_LENGTH} caratteri)`,
});
/** Corpo di `POST /products/:id/record-reference-types`. */
exports.createRecordReferenceTypeSchema = zod_1.z.object({
    key: exports.recordReferenceTypeKeySchema,
    label: exports.recordReferenceTypeLabelSchema,
});
/** Corpo di `PATCH /products/:id/record-reference-types/:key`: solo l'etichetta, la chiave è stabile. */
exports.updateRecordReferenceTypeSchema = zod_1.z.object({ label: exports.recordReferenceTypeLabelSchema });
/**
 * Chi dichiara un committente del prodotto: almeno un consumer attivo, solo consumer revocati,
 * oppure nessun consumer (il committente è uscito da tutti, ma ha una regola salvata che si
 * conserva e che erediterà se tornerà in un consumer).
 */
exports.COMMITTENTE_DECLARATIONS = ['consumer-attivo', 'solo-revocati', 'nessuno'];
exports.COMMITTENTE_DECLARATION_LABELS = {
    'consumer-attivo': 'Dichiarato',
    'solo-revocati': 'Solo consumer revocati',
    nessuno: 'Non più dichiarato',
};
//# sourceMappingURL=product-config.js.map